const DEV_MODE = process.env.REACT_APP_DEV_MODE;
export default DEV_MODE;
